export default __webpack_public_path__ + "static/media/gallery.31e1a6cf.svg";